export default __webpack_public_path__ + "static/media/low_violet.71d135fc.png";